import Component from "@glimmer/component";
import { action } from "@ember/object";
import { service } from "@ember/service";
import DButton from "discourse/ui-kit/d-button";
import dIcon from "discourse/ui-kit/helpers/d-icon";
import dLoadingSpinner from "discourse/ui-kit/helpers/d-loading-spinner";
import { i18n } from "discourse-i18n";

export default class ModMarketRouteStatus extends Component {
  @service router;

  get errorDescription() {
    return (
      this.args.error?.jqXHR?.responseJSON?.errors?.[0] ||
      this.args.error?.responseJSON?.errors?.[0] ||
      i18n("discourse_mod_market.error.description")
    );
  }

  @action
  retry() {
    this.router.transitionTo(this.router.currentURL);
  }

  <template>
    <section
      class="mod-market-route-status"
      role={{if @loading "status" "alert"}}
    >
      {{#if @loading}}
        {{dLoadingSpinner}}
        <h1>{{i18n "discourse_mod_market.loading.title"}}</h1>
        <p>{{i18n "discourse_mod_market.loading.description"}}</p>
      {{else}}
        {{dIcon "triangle-exclamation"}}
        <h1>{{i18n "discourse_mod_market.error.title"}}</h1>
        <p>{{this.errorDescription}}</p>
        <DButton
          @action={{this.retry}}
          @icon="rotate"
          @label="discourse_mod_market.error.retry"
          class="btn-primary"
        />
      {{/if}}
    </section>
  </template>
}
